import { type RtmStatus, rtmStatusTone } from '@/lib/oi/rtmStatus';

// Mockup `_tpInjectOIs` / `selectExternalOI` status pill — solid `statusBg`
// fill, keyed off the same RTM status tone as the badges (ENG-213).
const FILL: Record<ReturnType<typeof rtmStatusTone>, string> = {
  ok: 'bg-(--color-green-mid)',
  info: 'bg-(--color-blue)',
  warn: 'bg-(--color-amber-light)',
  crit: 'bg-(--color-red)',
  muted: 'bg-(--color-text3)',
};

export const oiStatusFill = (s: RtmStatus): string => FILL[rtmStatusTone(s)];
